import type { Configuration } from "@azure/msal-browser";
import { BrowserCacheLocation } from "@azure/msal-browser";
import type { RequiredConfig } from "../config";

/**
 * Builds the `PublicClientApplication` configuration from runtime config
 * (ISSUE-329 Deliverable C, step 6; ADR-055 §4). Authorization code + PKCE is
 * `msal-browser`'s only auth-code flow — there is no flag to disable it and
 * no field for a client secret, matching ADR-055 §7's "no client secret
 * anywhere" invariant.
 *
 * `redirectUri` is always `window.location.origin` — there is no
 * redirect-URI tunable (ISSUE-329 §Tunable parameters) — so the one built
 * artifact is correct on every origin it is deployed to, once that origin is
 * registered as a redirect URI in Entra (blocker P1).
 */
export function buildMsalConfig(config: RequiredConfig): Configuration {
  return {
    auth: {
      clientId: config.entraClientId,
      authority: config.entraAuthority,
      redirectUri: window.location.origin,
      postLogoutRedirectUri: window.location.origin,
    },
    cache: {
      // MSAL's own cache, `sessionStorage` — never `localStorage` and never a
      // hand-rolled store (ADR-055 §4 binding invariant).
      cacheLocation: BrowserCacheLocation.SessionStorage,
    },
  };
}
